<div class="table-light-wrapper">
    <table
        class="table table-hover table-striped"
        [ngStyle]="{ 'min-width': getTotalWidth() + 'px' }"
    >
        <thead>
            <tr>
                <ng-container *ngFor="let column of columns">
                    <th
                        *ngIf="column.visible !== false"
                        [attr.width]="column.width + 'px'"
                        [ngStyle]="{ left: getLeftBuffer(column, j) }"
                        [ngClass]="column.styleClass"
                    >
                        {{ column.header }}
                    </th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of data; let i = index; trackBy: trackChanges">
                <ng-container *ngFor="let column of columns; let j = index">
                    <td
                        *ngIf="column.visible !== false"
                        class="cell"
                        [ngStyle]="{ left: getLeftBuffer(column, j) }"
                        [ngClass]="column.styleClass"
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                column.template;
                                context: buildContext(row, column, i)
                            "
                        ></ng-container>
                    </td>
                </ng-container>
            </tr>
            <tr *ngIf="data.length == 0">
                <td [attr.colspan]="getVisibleColumnsLength()">
                    No results found...
                </td>
            </tr>
        </tbody>
        <tfoot *ngIf="showFooter">
            <tr>
                <ng-container *ngFor="let column of columns">
                    <td
                        *ngIf="column.visible !== false"
                        [ngStyle]="{ left: getLeftBuffer(column, j) }"
                        [ngClass]="column.styleClass"
                    >
                        {{ getFooterContent(column) }}
                    </td>
                </ng-container>
            </tr>
        </tfoot>
    </table>
</div>
